import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "addons-main-item" }
const _hoisted_2 = {
  key: 0,
  class: "addons-main-item__wrapper"
}
const _hoisted_3 = { class: "addons-main-item__title h4" }
const _hoisted_4 = {
  key: 0,
  class: "addons-main-item__unit"
}
const _hoisted_5 = { class: "addons-main-item__unit" }
const _hoisted_6 = { class: "addons-main-item__unit-wrapper" }
const _hoisted_7 = { class: "addons-main-item__unit-value h3 color-white" }
const _hoisted_8 = { class: "addons-main-item__unit-maximum caption-small normal color-text-tertiary" }
const _hoisted_9 = {
  key: 1,
  class: "addons-main-item__services"
}
const _hoisted_10 = { class: "addons-main-item__description caption-small" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = {
  key: 1,
  class: "addons-main-item__wrapper --addition"
}
const _hoisted_15 = { class: "addons-main-item__addition" }
const _hoisted_16 = { class: "addons-main-item__addition-text button-medium" }

import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { PropType } from "@vue/runtime-core";
import { AddonsItemStruct } from "@/struct/AddonsStruct";
import { formatAmountInput } from "@/utils/format";
import "swiper/css";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";
import BaseIcon from "@/components/base/BaseIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AddonsMainItem',
  props: {
  option: {
    type: Object as PropType<AddonsItemStruct | null>,
    default: null,
  },
  isAddition: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const { t } = useI18n();

const getUnit = computed(() => {
  switch (props.option?.unitData?.id) {
    case "sms":
      return t("common.units.sms");
    case "gb":
      return t("common.units.gb");
    case "min":
      return t("common.units.min");
    default:
      return "";
  }
});

const fullness = computed(() => {
  if (!props.option?.unitData) return;

  return Math.floor(
    (props.option.unitData.value / props.option.unitData.maximum) * 100
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.isAddition && __props.option)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(__props.option.title), 1),
          (__props.option.unitData)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", {
                    style: _normalizeStyle(`width: ${fullness.value}%`),
                    class: "addons-main-item__unit-progress"
                  }, null, 4),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", null, _toDisplayString(Math.round(__props.option.unitData.value)) + " " + _toDisplayString(getUnit.value), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)("common.labels.of")) + " " + _toDisplayString(Math.round(__props.option.unitData.maximum)), 1)
                    ])
                  ])
                ])
              ]))
            : (__props.option.servicesList && __props.option.servicesList.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.option.servicesList, (img, index) => {
                    return (_openBlock(), _createBlock(BaseIcon, {
                      key: index,
                      name: img,
                      folder: "service",
                      "is-original-color": ""
                    }, null, 8, ["name"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            (__props.option.amount)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(formatAmountInput)(__props.option.amount)) + "₽", 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(t)("common.labels.free")), 1)),
            (__props.option.date)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                  _cache[0] || (_cache[0] = _createTextVNode(" ,")),
                  _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.activeUntil")) + " " + _toDisplayString(__props.option.date), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(BaseFigureForIcon, {
              icon: "plus",
              color: "secondary",
              size: "small",
              "is-button": ""
            }),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)("addons.item.addOption")), 1)
            ])
          ])
        ]))
  ]))
}
}

})